import { render, staticRenderFns } from "./MoveInput.vue?vue&type=template&id=e70b8e22&scoped=true&"
import script from "./MoveInput.vue?vue&type=script&lang=js&"
export * from "./MoveInput.vue?vue&type=script&lang=js&"
import style0 from "./MoveInput.vue?vue&type=style&index=0&id=e70b8e22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70b8e22",
  null
  
)

export default component.exports